module.exports = __webpack_public_path__ + "media/homePageVideo.94466657.mp4";